const emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class Validator {
  static validateEmail(email) {
    return email === '' || emailRE.test(email);
  }
}

export default Validator;



// WEBPACK FOOTER //
// ./src/lib/validator.js